// src/TermsOfService.js
import React from "react";
import logo from "./logo.svg";

const TermsOfService = ({ appName }) => {
  const termsOfServiceContent = `
1. 接受條款
  使用 ${appName}（以下簡稱“本應用”）即表示您同意遵守這些服務條款。如果您不同意這些條款，請不要使用本應用。

2. 使用權限
  我們授予您非獨佔、不可轉讓的權利，以個人和非商業目的使用本應用。您不得將本應用用於非法目的或違反任何適用法律。

3. 用戶責任
  您同意：
    不發佈或傳輸任何非法、猥褻、誹謗或有害的內容。
    不干擾或破壞本應用的運作。
    不未經授權訪問其他用戶的帳戶或數據。

4. 知識產權
  本應用及所有內容、設計和技術均為我們或我們的授權人所有，受版權和其他知識產權法的保護。您不得在未經許可的情況下複製、修改、分發或利用任何內容。

5. 責任限制
  我們對於您使用本應用而產生的任何直接、間接、偶然、特別或後果性損害不承擔責任，包括數據損失或利潤損失。

6. 服務中斷
  我們保留在任何時候修改、暫停或終止本應用的權利，恕不另行通知。我們不對任何中斷或服務損失負責。

7. 條款變更
  我們可能不定期更新這些服務條款。更新的條款將發布在此頁面上，您繼續使用本應用即表示接受新條款。

8. 管轄法律
  這些條款受 [適用法律] 的法律管轄。如果任何條款被發現無效或不可執行，其餘條款仍然有效。

9. 聯繫我們
  如對這些服務條款有任何疑問或擔憂，請聯繫我們：
  電子郵件: otislin1102@gmail.com
`;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        width: "100vw",
        overflowY: "auto",
      }}
    >
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div
        style={{
          textAlign: "left",
          padding: "20px",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
        }}
      >
        <h1 className="main-font-color">服務條款</h1>
        <div className="main-font-color">{termsOfServiceContent}</div>
      </div>
    </div>
  );
};

export default TermsOfService;
